import endpoints from 'constants/endpoints';
import {
  SET_MARKETING_ASSETS,
  SET_MARKETING_ASSETS_ERROR
} from 'constants/types';
import { safePostCall } from 'helpers/firebaseSetup';

export const getMarketingAssets = (
  setLocalLoader = () => {},
  cancelTokenSource = {}
) => {
  return async dispatch => {
    try {
      setLocalLoader(true);
      const response = await safePostCall(
        endpoints.awsProxy.safePost,
        {
          endpoint: endpoints.zoho.getMarketingAssets,
          isZohoRequest: true
        },
        { cancelToken: cancelTokenSource.token }
      );

      if (response?.data?.details?.output) {
        const parsedData = JSON.parse(response.data.details.output);
        dispatch({ type: SET_MARKETING_ASSETS, payload: parsedData });
      } else {
        dispatch({
          type: SET_MARKETING_ASSETS_ERROR,
          payload: 'An error occurred while fetching marketing assets'
        });
        console.error('Unexpected response structure', response);
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (cancelTokenSource?.token?.reason?.message !== 'API Call Canceled') {
        setLocalLoader(false);
      }
    }
  };
};
